import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { 
  Plus, X, Wrench, Receipt, Shield, FileText
} from 'lucide-react';

const QuickActionMenu = ({ 
  open, 
  onOpenChange, 
  onLogService, 
  onAddReceipt, 
  onAddProtection,
  theme 
}) => {
  const actions = [
    { 
      label: 'Log Service', 
      icon: Wrench, 
      onClick: onLogService,
      color: 'bg-teal-500 hover:bg-teal-600'
    },
    { 
      label: 'Add Receipt', 
      icon: Receipt, 
      onClick: onAddReceipt,
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    { 
      label: 'Add Protection', 
      icon: Shield, 
      onClick: () => onAddProtection(),
      color: 'bg-purple-500 hover:bg-purple-600'
    },
  ];

  return (
    <div className="fixed bottom-20 right-4 z-50">
      {/* Action Buttons */}
      <div className={`flex flex-col gap-2 mb-2 transition-all duration-200 ${open ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
        {actions.map((action, index) => (
          <Button
            key={action.label}
            className={`${action.color} text-white shadow-lg flex items-center gap-2 justify-start px-4`}
            onClick={action.onClick}
            style={{
              transitionDelay: open ? `${index * 50}ms` : '0ms'
            }}
          >
            <action.icon className="h-4 w-4" />
            <span>{action.label}</span>
          </Button>
        ))}
      </div>

      {/* Main FAB */}
      <Button
        size="lg"
        className={`w-14 h-14 rounded-full shadow-lg transition-all duration-200 ${
          open 
            ? 'bg-slate-700 hover:bg-slate-800 rotate-45' 
            : 'hover:opacity-90'
        }`}
        style={!open ? { backgroundColor: theme.dark } : {}}
        onClick={() => onOpenChange(!open)}
        data-testid="quick-action-fab"
      >
        {open ? (
          <X className="h-6 w-6 text-white" />
        ) : (
          <Plus className="h-6 w-6 text-white" />
        )}
      </Button>

      {/* Backdrop */}
      {open && (
        <div 
          className="fixed inset-0 bg-black/20 -z-10"
          onClick={() => onOpenChange(false)}
        />
      )}
    </div>
  );
};

export default QuickActionMenu;
